export function parseDate(date: string): Date | null {
    const match = date.match(/^(\d{2}).(\d{2}).(\d{4})$/);
    return match ? new Date(`${match[3]}-${match[2]}-${match[1]}`) : null;
}
